// eslint-disable-next-line @typescript-eslint/triple-slash-reference -- typings.d.ts provides *.graphql module declaration needed when compiling from dependent projects
/// <reference path="../../typings.d.ts" />
import getAemContentPolarisTabCollectionQueryDefault from './getAemContentPolarisTabCollection.graphql';
import { DocumentNode } from 'graphql';

export const getAemContentPolarisTabCollectionQuery: DocumentNode =
  getAemContentPolarisTabCollectionQueryDefault as unknown as DocumentNode;
